let state = {
    inited: false,
    on_training: false,
    is_new: true,
    user_state: 0, // 0 未关注，1已关注
    nickname: "abc", //孩子姓名
    icon: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/wechat/2017/12/13/27151121513155768.jpg?x-oss-process=image/resize,m_fill,h_100,w_100", // 头像
    birthday: "1420041600",
    age: "",
    remind_time: "00:00",
    point: "130",
    city: "北京",
    city_id: "1",
    province_id: "1",
    province: "北京",
    uid: "375",
    complete: "true"
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitUserInfoPrev/state.js